const BANK_ACCOUNT_PARTNER_TYPE = {
	GREENDOT: 'greendot',
	STRIDE: 'core',
} as const;

export type BankAccountPartnerType =
	(typeof BANK_ACCOUNT_PARTNER_TYPE)[keyof typeof BANK_ACCOUNT_PARTNER_TYPE];

export default BANK_ACCOUNT_PARTNER_TYPE;
